// The living context of a blended search result, from the availability variant the backend matched.
// Mirrors app/Domain/Properties/Actions/BuildPropertyAvailabilityVariantsMetaAction.php - keep the two in step.
const VARIANT_WHOLE_PROPERTY = 'whole_property';
export const VARIANT_REMAINING_ROOMS = 'remaining_rooms';

/**
 * Only blended results carry variant context. Everything else - control searches, nearby results,
 * shortlists - falls back to the rendering it has today.
 */
export function hasLivingContext(property) {
  return (
    property?.variantKind === VARIANT_WHOLE_PROPERTY ||
    property?.variantKind === VARIANT_REMAINING_ROOMS
  );
}

function roomCounts(property) {
  const bedrooms = Number(property?.bedroomCount);
  const available = Number(property?.roomsAvailableCount);

  if (!Number.isInteger(bedrooms) || bedrooms < 1) {
    return null;
  }

  if (!Number.isInteger(available) || available < 0) {
    return null;
  }

  return { bedrooms, available, occupied: bedrooms - available };
}

function remainingRoomCounts(property) {
  const counts = roomCounts(property);

  if (
    property?.variantKind !== VARIANT_REMAINING_ROOMS ||
    counts === null ||
    counts.available === 0
  ) {
    return null;
  }

  return counts;
}

function roomsLabel(count) {
  return `${count} ${count === 1 ? 'room' : 'rooms'}`;
}

/**
 * A partially occupied home reads "1 room available" + "2 occupied", the chips spare room
 * adverts have always carried; together they explain a larger property appearing in a
 * search for fewer bedrooms.
 */
export function availabilityLabelFor(property) {
  const counts = remainingRoomCounts(property);

  return counts === null ? null : `${roomsLabel(counts.available)} available`;
}

export function occupancyLabelFor(property) {
  const counts = remainingRoomCounts(property);

  return counts === null || counts.occupied === 0
    ? null
    : `${counts.occupied} occupied`;
}
